import { restApiRP } from "@plannel/services/utils/rest-api";

const getAll = (params) => {
  return restApiRP.get("/api/rp/monthly/trend", { params });
};

const getChart = (params) => {
  return restApiRP.get("/api/rp/monthly/trend/chart", { params });
};

const getAllForCSV = (params) => {
  return restApiRP.get("/api/rp/monthly/trend/csv", { params });
};

const rpMonthlyCategoryLocationService = {
  getAll,
  getChart,
  getAllForCSV
};

export default rpMonthlyCategoryLocationService;